angular.module('eStories.seo.model', [])
    .service('SeoModel', ['$rootScope', '$location', '$window', '$filter', function ($rootScope, $location, $window, $filter) {
        var model = this;

        model.applyExtraTags = function (
            {
                imageContentValue = 'https://d186ft2re9f5xl.cloudfront.net/assets/img/og_image/media_default_estories@2x.jpg',
                imageSize = 500
            } = {}) {

            $rootScope.imageContentValue = imageContentValue;
            $rootScope.ogImageSizeValue = imageSize;
            $rootScope.ogUrlValue = window.location.href;
            $window.finishedLoading = true;
        };

        model.catalogCount = '120,000';
        model.freeCatalogCount = '9,500';
        model.catalogCountAbrevs = '120K';

        model.applyMetaTags = function (state, stateParams) {
            switch (state) {
                case 'eStories.navbars':
                    $rootScope.titleContentValue = 'eStories | Hear Something New | eStories.com';
                    $rootScope.titleValue = `eStories audiobooks | Discover over ${model.catalogCount} audiobooks | Start Listening Now at eStories.com`;
                    $rootScope.descriptionContentValue = `Choose from over ${model.catalogCount} audiobook titles, including NYT bestsellers and the latest releases, or listen to over over ${model.freeCatalogCount} free audiobooks. Stream or download.`;
                    break;
                case 'eStories.navbars.browse':
                    $rootScope.titleContentValue = 'View All Audiobook Categories | eStories.com';
                    $rootScope.titleValue = 'View All Audiobook Categories | eStories.com';
                    $rootScope.descriptionContentValue = "View all eStories audiobook categories and genres. Browse bestselling audio books in fiction, non-fiction, business, sci-fi, mysteries, thrillers and more.";
                    break;
                case 'eStories.navbars.browseGenre':
                    $rootScope.titleContentValue = `Listen to ${stateParams} audiobooks | eStories.com`;
                    $rootScope.titleValue = `Listen to ${stateParams} audiobooks | eStories.com`;
                    $rootScope.descriptionContentValue = `Listen to ${stateParams} audiobooks. Choose from more than ${model.catalogCount} audiobook titles, including NYT bestsellers and the latest releases, or listen to over ${model.freeCatalogCount} free audiobooks. Stream or download audiobooks to your computer, iPhone or Android.`;
                    break;
                case 'eStories.navbars.howItWorks':
                    $rootScope.titleContentValue = 'eStories audiobooks | How it Works | eStories.com';
                    $rootScope.titleValue = 'eStories audiobooks | How it Works | eStories.com';
                    $rootScope.descriptionContentValue = `Choose from more than ${model.catalogCount} audiobook titles, including NYT bestsellers and the latest releases, or listen to over ${model.freeCatalogCount} free audiobooks. Stream or download audiobooks to your computer, iPhone or Android.Stream or download stories to your iPhone, iPad, Android, PC or Mac.`;
                    break;
                case 'eStories.navbars.plans':
                    $rootScope.titleContentValue = 'eStories audiobooks | eStories Subscription Plans | Start Listening Now at eStories.com';
                    $rootScope.titleValue = 'eStories audiobooks | eStories Subscription Plans | Start Listening Now at eStories.com';
                    $rootScope.descriptionContentValue = `Members get the best audiobook prices. Choose from more than ${model.catalogCount} audiobook titles, including NYT bestsellers and the latest releases, or listen to over ${model.freeCatalogCount} free audiobooks. Stream or download audiobooks to your computer, iPhone or Android.`;
                    break;
                case 'eStories.navbars.freeaudiobook':
                    $rootScope.titleContentValue = 'eStories audiobooks | Start your listening adventure | Start Listening Now at eStories.com';
                    $rootScope.titleValue = 'eStories audiobooks | Start your listening adventure | Start Listening Now at eStories.com';
                    $rootScope.descriptionContentValue = `Members get the best audiobook prices. Choose from more than ${model.catalogCount} audiobook titles, including NYT bestsellers and the latest releases, or listen to over ${model.freeCatalogCount} free audiobooks. Stream or download audiobooks to your computer, iPhone or Android.`;
                    break;
                case 'eStories.navbars.seeAll':
                    let pageType;
                    if (stateParams.indexOf("new_releases") > -1) {
                        pageType = 'New Releases';
                        $rootScope.titleContentValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.titleValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.descriptionContentValue = "Stream or download the latest releases to your iPhone, iPad, Android, PC or Mac."
                    } else if (stateParams.indexOf("new_york_times_best_sellers") > -1) {
                        pageType = "NYT Bestsellers";
                        $rootScope.titleContentValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.titleValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.descriptionContentValue = `Choose one of our NYT Bestsellers for an amazing listening experience. Choose from ${model.catalogCount}+ audiobooks and stream or download stories to your iPhone, iPad, Android, PC or Mac.`;
                    } else if (stateParams.indexOf("great_first_") > -1) {
                        pageType = "Great First Listens";
                        $rootScope.titleContentValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.titleValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.descriptionContentValue = `Choose one of our First Listen recommendations for an amazing listening experience. Choose from ${model.catalogCount}+ audiobooks and stream or download stories to your iPhone, iPad, Android, PC or Mac.`;
                    } else if (stateParams.indexOf("best_sellers") > -1) {
                        pageType = "Bestsellers";
                        $rootScope.titleContentValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.titleValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.descriptionContentValue = `Choose one of our bestselling audiobooks for an amazing listening experience. Choose from ${model.catalogCount}+ audiobooks and stream or download stories to your iPhone, iPad, Android, PC or Mac.`;
                    } else if (stateParams.indexOf("editors_picks") > -1) {
                        pageType = "Editors' Picks";
                        $rootScope.titleContentValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.titleValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.descriptionContentValue = `Choose one of our ${pageType} for an amazing listening experience. Choose from ${model.catalogCount}+ audiobooks and stream or download stories to your iPhone, iPad, Android, PC or Mac.`;
                    } else if (stateParams.indexOf("on_sale") > -1) {
                        pageType = "Audiobooks Sale";
                        $rootScope.titleContentValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.titleValue = `eStories audiobooks | ${pageType} | eStories.com`;
                        $rootScope.descriptionContentValue = 'Save big on the latest Audiobooks. Sale Ends Soon!';
                    }
                    break;
                case "eStories.navbars.affiliates":
                    $rootScope.titleContentValue = 'eStories audiobooks | Affiliate Program | eStories.com';
                    $rootScope.titleValue = 'eStories audiobooks | Affiliate Program | eStories.com';
                    $rootScope.descriptionContentValue = `Become an affiliate today and start earning. Promote exclusive offers and a premium catalog with over ${model.catalogCount} audiobooks, including NYT bestsellers and the latest releases.`;
                    break;
            }
            model.applyExtraTags();
        };

        model.applyPublisherMetaTags = function (publisher) {
            $rootScope.titleValue = `Listen to audiobooks from ${publisher} | eStories.com`;
            $rootScope.titleContentValue = `Listen to audiobooks from ${publisher} | eStories.com`;
            $rootScope.descriptionContentValue = `Listen to audiobooks from ${publisher}. Stream or download audiobooks to your computer, iPhone or Android.`;
            $rootScope.keywordsContentValue = `audiobook, audiobooks, ${publisher}, free audiobook, free audiobooks, audio book, audio books, books online, ios books, android books`;
            model.applyExtraTags();
        };

        model.applyNarratorMetaTags = function (narrator) {
            $rootScope.titleValue = `${narrator} | eStories.com `;
            $rootScope.titleContentValue = `Listen to audiobooks narrated by ${narrator} | eStories.com`;
            $rootScope.descriptionContentValue = `Listen to audiobooks narrated by ${narrator}. Stream or download audiobooks to your computer, iPhone or Android.`;
            $rootScope.keywordsContentValue = `audiobook, audiobooks, ${narrator}, free audiobook, free audiobooks, audio book, audio books, books online, ios books, android books`;
            model.applyExtraTags();

        };

        model.applyBookDetailsMetaTags = function (audiobook) {
            if (!audiobook) {
                return;
            }
            const genreList = audiobook.genreList.map(v => v.name).join(" audiobook, ");
            const narratorList = audiobook.narratorList.map(v => v.name).join(", ");
            const authorList = audiobook.authorList.map(v => v.name).join(", ");
            const title = audiobook.title;

            //JSON LD for google breadcrumbs
            model.formatJSONLDBreadcrumbs(audiobook.genreList[0]);

            //Meta tag updates for Open Graph
            $rootScope.titleValue = `${title} | ${authorList} | eStories.com `;
            $rootScope.titleContentValue = `Listen to ${title} by ${authorList} | eStories.com`;
            $rootScope.descriptionContentValue = `Listen to ${title} by ${authorList}. Stream or download audiobooks to your computer, iPhone or Android.`;
            $rootScope.keywordsContentValue = `audiobook, audiobooks, ${title}, free ${title}, ${authorList}, ${genreList} audiobook, ${narratorList}, free audiobook, free audiobooks, audio book, audio books, books online, ios books, android books, free ${title} audiobook, free ${title} audio book`;

            let imageContentValue = `${$filter('imageByWidth')(audiobook.coverUrl, 300)}`;
            model.applyExtraTags({imageContentValue: imageContentValue, imageSize: 300});
        };

        model.applyAuthorMetaTags = function (author) {
            $rootScope.titleValue = `Listen to audiobooks by ${author} | eStories.com `;
            $rootScope.titleContentValue = `Listen to audiobooks by ${author} | eStories.com`;
            $rootScope.descriptionContentValue = `Listen to audiobooks by ${author}. Stream or download audiobooks to your computer, iPhone or Android.`;
            $rootScope.keywordsContentValue = `audiobook, audiobooks, ${author}, free audiobook, free audiobooks, audio book, audio books, books online, ios books, android books`;
            model.applyExtraTags();

        };

        $rootScope.$root.orgLd = {
            "@context": "http://schema.org/",
            "@type": "Organization",
            "name": 'eStories',
            "image": $window.location.origin + "/assets/img/home/eStories-logo-black-yellow.png",
            "description": 'Find Your Next Favorite Audiobook, Listen Everywhere you Go, and Get Great Member Benefits',
            "url": 'https://estories.com/',

            "logo": $window.location.origin + "/assets/img/home/eStories-icon-logo.png",
            "sameAs": [
                "https://www.facebook.com/eStoriesaudiobooks", "https://twitter.com/eStoriesForYou", "https://www.linkedin.com/company/triplay", "https://www.instagram.com/estoriesforyou"
            ],
            "address": {
                "@type": "PostalAddress",
                "addressCountry": "United States",
                "addressLocality": "New York",
                "addressRegion": "NY",
                "streetAddress": "215 Lexington, Suite 1800",
                "postalCode": "10016"
            },
            "telephone": "(212) 372-6019",
            "contactPoint": [{
                "@type": "ContactPoint",
                "telephone": "+1-212-372-6019",
                "contactType": "customer service",
                "areaServed": [
                    "US"
                ],
                "availableLanguage": [
                    "English"
                ]
            }]
        };

        $rootScope.$root.siteLd = {
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "eStories",
            "url": "https://www.estories.com",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://www.estories.com/search/store/{search_term_string}",
                "query-input": "required name=search_term_string"
            }
        };

        model.formatJSONLDBreadcrumbs = function (genreObj) {
            var hasThirdBreadcrumb = genreObj.parentGenreName;
            $rootScope.$root.breadcrumbsLd = {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": {
                        "@id": $window.location.origin + "/browse",
                        "name": "Browse"
                    }
                }, {
                    "@type": "ListItem",
                    "position": 2,
                    "item": {
                        "@id": `${$window.location.origin}/genres/${genreObj.parentGenreName ? (genreObj.parentGenreName.replace(/ /g, "_")) : (genreObj.name.replace(/ /g, "_"))}`,
                        "name": (genreObj.parentGenreName ? genreObj.parentGenreName : genreObj.name),
                    }
                }]
            };

            if (hasThirdBreadcrumb) {
                var thirdBreadcrumb = {
                    "@type": "ListItem",
                    "position": 3,
                    "item": {
                        "@id": `${$window.location.origin}/genres/${genreObj.parentGenreName.replace(/ /g, "_")}?genreId=${genreObj.parentGenreId}&subGenreId=${genreObj.id}`,
                        "name": genreObj.name,
                    }
                };
                $rootScope.$root.breadcrumbsLd["itemListElement"].push(thirdBreadcrumb)
            }
        };
    }]);
